module.exports = __webpack_public_path__ + "img/2.4.NH3-N.1c65e1cc.png";